<ng-template #drawerTemplate>
  <nav
    class="fixed inset-y-0 left-0 w-72 z-[201] bg-surface-container-low flex flex-col shadow-[4px_0_24px_rgba(61,26,110,0.12)]"
    cdkTrapFocus
    cdkTrapFocusAutoCapture
    data-testid="mobile-drawer"
  >
    <app-sidebar [closable]="true" (closeRequested)="requestClose()" />
  </nav>
</ng-template>
